export default __webpack_public_path__ + "static/media/pantry1-afterE-480w.721f6fb3.webp";